import { useEffect } from 'react'
import { Github, Linkedin, Mail } from 'lucide-react'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { Button } from '@/components/ui/button'
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar'
import { PageHeader } from '@/components/layout'
import { useAppDispatch } from '@/store/hooks'
import { visitPage } from '@/store/slices/gamificationSlice'

export default function About() {
  const dispatch = useAppDispatch()

  // Track page visit for explorer achievement
  useEffect(() => {
    dispatch(visitPage('about'))
  }, [dispatch])

  return (
    <div className="space-y-6 max-w-3xl mx-auto">
      <PageHeader 
        title="About" 
        description="Learn more about the creator of this financial planning tool."
      />

      <Card>
        <CardHeader className="text-center">
          <Avatar className="h-24 w-24 mx-auto mb-4">
            <AvatarImage src="/images/kevin headshot.jpeg" alt="Kevin" />
            <AvatarFallback className="text-2xl">K</AvatarFallback>
          </Avatar>
          <CardTitle className="text-2xl">Kevin</CardTitle>
          <CardDescription>Software Engineer & Financial Planning Enthusiast</CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <p className="text-muted-foreground">
            Hi! I'm Kevin, a software engineer passionate about personal finance and helping others 
            take control of their financial future. I built this tool to simplify financial planning 
            and make it accessible to everyone.
          </p>
          <p className="text-muted-foreground">
            This application combines my expertise in software development with my interest in 
            personal finance to create a comprehensive tool for budgeting, investment tracking, 
            debt management, and retirement planning.
          </p>
          <div className="flex justify-center gap-4 pt-4">
            <Button variant="outline" size="icon">
              <Github className="h-4 w-4" />
            </Button>
            <Button variant="outline" size="icon">
              <Linkedin className="h-4 w-4" />
            </Button>
            <Button variant="outline" size="icon">
              <Mail className="h-4 w-4" />
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  )
}
